import { PageHeader } from "@ant-design/pro-components";
import { Button, Col, Divider, Input, List, Row, Tag } from "antd";
import { observer } from 'mobx-react';
import React, { ChangeEvent, MouseEvent, useEffect } from "react";
import SelectrorItemStore from "../../stores/common/selector-item";
import { useStore } from "../../stores/root-store";
import Subjects from "../../models/subjects";

const DictionaryItem: React.FC<{ item: SelectrorItemStore }> = ({ item }) => {

    const handleDeleteSource = (event: MouseEvent<HTMLAnchorElement>) => {
        item.deleteItem();
    }

    return <List.Item
        key={item.id}
        actions={[
            <Button type="link" onClick={handleDeleteSource}>удалить</Button>
        ]}
    >
        <Tag>{item.id}</Tag>
        {item.name}
    </List.Item>;
}

const Dictionaries: React.FC<{subject: Subjects}> = ({subject}) => {

    const { authStore, subjectStores } = useStore();
    const taskFilter = subjectStores[subject].taskFilter;

    useEffect(() => {
        if (authStore.isAuthenticated) {
            taskFilter.source.loadDictionary();
            taskFilter.theme.loadDictionary();
        }
    }, [authStore.isAuthenticated, taskFilter.source, taskFilter.theme]
    );

    const handleCreateSource = () => {
        taskFilter.source.createItem();
    }

    const handleChangeSource = (event: ChangeEvent<HTMLInputElement>) => {
        taskFilter.source.setNewItem(event.target.value);
    }

    return <div className="content">
        <PageHeader title="Словари" className="site-page-header" />

        <Row>
            <Col span={12} style={{ paddingRight: "20px" }}>
                <Divider orientation="left">Источник</Divider>
                <List
                    size="small"
                    bordered
                    dataSource={taskFilter.source.items}
                    renderItem={(i) =>
                        <DictionaryItem {...{ item: new SelectrorItemStore(i.id, i.name, taskFilter.source) }} />
                    }
                    className="basic-control"
                />
                <Input placeholder="введите название" onChange={handleChangeSource} className="basic-control" value={taskFilter.source.newItem} />
                <Button type="primary" onClick={handleCreateSource}>Добавить</Button>
            </Col>
            <Col span={12}>
                <Divider orientation="left">Тема</Divider>
                <List
                    size="small"
                    bordered
                    dataSource={taskFilter.theme.items}
                    renderItem={(item) => <List.Item><Tag>{item.id}</Tag>{item.name}</List.Item>}
                    className="basic-control"
                />
                <Input placeholder="введите название" className="basic-control" />
                <Button type="primary">Добавить</Button>
            </Col>
        </Row>
    </div>;
}

export default observer(Dictionaries);